import defaultTheme from 'tailwindcss/defaultTheme';

import { useMediaQuery } from './useMediaQuery';

export type TailwindBreakpoint = keyof typeof defaultTheme.screens;

export function useTailwindBreakpoint(name: TailwindBreakpoint) {
  const minWidth = defaultTheme.screens[name];
  return useMediaQuery(`(min-width: ${minWidth})`);
}
